module.exports = __webpack_public_path__ + "media/images/icons/cabal_credito-f8a451a327812c549416fbf54aba319d.png";